import React from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import LoginInput from '../../components/input/LoginInput';
import {
  TITLE_LOGIN,
  TITLE_LOGIN_EN,
  TITLE_LOGIN_NO_ACCOUNT,
  TITLE_LOGIN_NO_ACCOUNT_EN,
  TITLE_REGISTER_HERE,
  TITLE_REGISTER_HERE_EN,
  URL_HOME,
  URL_REGISTER,
} from '../../utils/common/constant';
import { asyncSetAuthUser } from '../../middleware/authUser/action';
import { SectionLoginPage } from '../../components/styled';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locale = 'en';

  const onLogin = ({ email, password }) => {
    dispatch(asyncSetAuthUser({ email, password }));
    navigate(URL_HOME);
  };

  return (
    <SectionLoginPage>
      <h2>{locale === 'id' ? TITLE_LOGIN : TITLE_LOGIN_EN}</h2>
      <LoginInput login={onLogin} />
      <p>
        {locale === 'id' ? TITLE_LOGIN_NO_ACCOUNT : TITLE_LOGIN_NO_ACCOUNT_EN}
        &nbsp;
        <Link to={URL_REGISTER}>{locale === 'id' ? TITLE_REGISTER_HERE : TITLE_REGISTER_HERE_EN}</Link>
      </p>
    </SectionLoginPage>
  );
};

export default LoginPage;
